// 01. Function to clear alt attributes from images in the Rebuy Smart Cart
// This function selects all images within a specific element and removes their alt attributes
function clearAltAttributes() {
  const images = document.querySelectorAll(
    ".rebuy-cart__flyout-recommendations img",
  );
  images.forEach(function (img) {
    img.removeAttribute("alt");
  });
}

// Function to set aria-hidden attributes to true for image links in the Rebuy Smart Cart
// This function selects all image links within a specific element and sets aria-hidden=true
function updateAriaHiddenAttributes() {
  const imageLinks = document.querySelectorAll(
    ".rebuy-cart__flyout-recommendations .rebuy-product-image",
  );
  imageLinks.forEach((link) => {
    link.ariaHidden = "true";
  });
}

function updateDecorativeInjectedSvgAttributes() {
  const decorativeSvgSelectors = [
    "#junipStarSymbols",
    "#junipStarSymbols > svg",
    ".junip-star > svg",
    ".junip-verified-badge > svg",
    ".junip-rewarded > svg",
    "#rebuy-cart .rebuy-cart__progress-step-icon > svg",
  ];

  decorativeSvgSelectors.forEach((selector) => {
    document.querySelectorAll(selector).forEach((svg) => {
      svg.setAttribute("aria-hidden", "true");
      svg.setAttribute("focusable", "false");
      svg.setAttribute("role", "presentation");
    });
  });
}

const decorativeInjectedSvgObserverTargets = new WeakSet();
const decorativeInjectedSvgObserverTargetSelector =
  ".rebuy-cart__flyout, .junip-review-section, [id^='junipProductReviews']";
let decorativeInjectedSvgDebounce;
let decorativeInjectedSvgDiscoveryObserver;
function setupDecorativeInjectedSvgObserver() {
  const targets = document.querySelectorAll(
    decorativeInjectedSvgObserverTargetSelector,
  );

  targets.forEach((target) => {
    if (decorativeInjectedSvgObserverTargets.has(target)) return;

    const observer = new MutationObserver(function () {
      clearTimeout(decorativeInjectedSvgDebounce);
      decorativeInjectedSvgDebounce = setTimeout(() => {
        updateDecorativeInjectedSvgAttributes();
        updateInjectedComponentAccessibility();
      }, 100);
    });
    observer.observe(target, { childList: true, subtree: true });
    decorativeInjectedSvgObserverTargets.add(target);
  });

  if (decorativeInjectedSvgDiscoveryObserver || !document.body) return;

  const discoveryObserver = new MutationObserver((mutations) => {
    const addedObserverTarget = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) =>
          node.nodeType === Node.ELEMENT_NODE &&
          (node.matches(decorativeInjectedSvgObserverTargetSelector) ||
            node.querySelector(decorativeInjectedSvgObserverTargetSelector)),
      ),
    );

    if (!addedObserverTarget) return;

    setupDecorativeInjectedSvgObserver();
    updateDecorativeInjectedSvgAttributes();
    updateInjectedComponentAccessibility();
  });
  decorativeInjectedSvgDiscoveryObserver = discoveryObserver;
  discoveryObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  setTimeout(() => {
    if (decorativeInjectedSvgDiscoveryObserver !== discoveryObserver) return;

    setupDecorativeInjectedSvgObserver();
    updateDecorativeInjectedSvgAttributes();
    updateInjectedComponentAccessibility();
    discoveryObserver.disconnect();
    decorativeInjectedSvgDiscoveryObserver = null;
  }, 15000);
}

function updateSlickAccessibility() {
  document.querySelectorAll('.slick-track[role="listbox"]').forEach((track) => {
    track.setAttribute("role", "group");
    track.setAttribute("aria-roledescription", "carousel");
    if (!track.getAttribute("aria-label")) {
      track.setAttribute("aria-label", "Carousel");
    }
  });

  document.querySelectorAll('.slick-slide[role="option"]').forEach((slide) => {
    slide.setAttribute("role", "group");
    slide.setAttribute("aria-roledescription", "slide");
    slide.removeAttribute("aria-selected");
    slide.removeAttribute("aria-controls");
  });
}

const slickAccessibilityObserverTargets = new WeakSet();
let slickAccessibilityDebounce;
function setupSlickAccessibilityObservers() {
  document.querySelectorAll(".slick-slider").forEach((target) => {
    if (slickAccessibilityObserverTargets.has(target)) return;

    const observer = new MutationObserver(function () {
      clearTimeout(slickAccessibilityDebounce);
      slickAccessibilityDebounce = setTimeout(updateSlickAccessibility, 50);
    });
    observer.observe(target, {
      attributes: true,
      attributeFilter: ["aria-hidden", "role"],
      childList: true,
      subtree: true,
    });
    slickAccessibilityObserverTargets.add(target);
  });
}

function updateHiddenInjectedIframeAttributes() {
  document
    .querySelectorAll('body > iframe:not([title])[style*="display: none"]')
    .forEach((iframe) => {
      iframe.setAttribute("title", "Hidden application frame");
      iframe.setAttribute("aria-hidden", "true");
      iframe.setAttribute("tabindex", "-1");
    });
}

let hiddenInjectedIframeObserver;
function setupHiddenInjectedIframeObserver() {
  if (hiddenInjectedIframeObserver || !document.body) return;

  hiddenInjectedIframeObserver = new MutationObserver(
    updateHiddenInjectedIframeAttributes,
  );
  hiddenInjectedIframeObserver.observe(document.body, { childList: true });
}

function updateInjectedComponentAccessibility() {
  const rebuyFlyout = document.querySelector(".rebuy-cart__flyout");
  const rebuyTitle = rebuyFlyout?.querySelector(".rebuy-cart__title");
  if (rebuyFlyout && rebuyTitle) {
    if (!rebuyTitle.id) rebuyTitle.id = "rebuy-cart-title";
    rebuyFlyout.setAttribute("role", "dialog");
    rebuyFlyout.setAttribute("aria-modal", "true");
    rebuyFlyout.setAttribute("aria-labelledby", rebuyTitle.id);
  }

  document.querySelectorAll(".rebuy-product-title").forEach((title) => {
    title.setAttribute("role", "heading");
    title.setAttribute("aria-level", "3");
  });

  document
    .querySelectorAll(".junip-product-review-bar-wrapper.junip-no-hover")
    .forEach((bar) => {
      bar.removeAttribute("role");
      bar.removeAttribute("tabindex");
      bar.removeAttribute("aria-label");
      bar.removeAttribute("aria-pressed");
    });

  document
    .querySelectorAll(".junip-review-grid-item-container[role='button']")
    .forEach((review) => {
      if (!review.querySelector("[role='button'], a[href], button")) return;
      review.setAttribute("role", "article");
      review.removeAttribute("tabindex");
    });

  document.querySelectorAll("square-placement").forEach((placement) => {
    const shadowRoot = placement.shadowRoot;
    if (!shadowRoot || shadowRoot.getElementById("theme-a11y-target-size")) return;

    const style = document.createElement("style");
    style.id = "theme-a11y-target-size";
    style.textContent =
      "#logo-link{min-width:24px;min-height:24px;display:inline-flex;align-items:center;justify-content:center;margin:-4px;}";
    shadowRoot.appendChild(style);
  });
}

function alignAccessibilityWidgetButton() {
  const shadowRoot = document.getElementById("INDShadowRootHost")?.shadowRoot;
  if (!shadowRoot) return false;
  if (shadowRoot.getElementById("theme-floating-widget-position")) return true;

  const style = document.createElement("style");
  style.id = "theme-floating-widget-position";
  style.textContent =
    ".INDpositionLeft #INDmenu-btn{top:auto!important;bottom:90px!important;left:20px!important;margin:0!important;transform-origin:left bottom!important;}";
  shadowRoot.appendChild(style);
  return true;
}

function setupAccessibilityWidgetAlignment() {
  if (alignAccessibilityWidgetButton() || !document.body) return;

  const observer = new MutationObserver(() => {
    if (alignAccessibilityWidgetButton()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true });
}

function updateAccessibleTableNames() {
  const tables = document.querySelectorAll(
    ".rte table, .shopify-policy__body table, #sc-content table",
  );
  const pageHeading = document.querySelector("main h1, #content h1, h1");
  const pageName =
    pageHeading?.textContent.trim() || document.title.split("–")[0].trim();

  tables.forEach((table, index) => {
    const firstRow = table.rows[0];
    const isSingleColumnSizeKey =
      table.closest("#sc-content") &&
      firstRow?.cells.length === 1 &&
      !table.querySelector("th");

    if (isSingleColumnSizeKey) {
      table.setAttribute("role", "presentation");
      return;
    }

    if (!table.querySelector("caption") && !table.getAttribute("aria-label")) {
      table.setAttribute("aria-label", `${pageName} table ${index + 1}`);
    }

    if (firstRow && !firstRow.querySelector("th")) {
      Array.from(firstRow.cells).forEach((cell) => {
        cell.setAttribute("role", "columnheader");
      });
    }
  });
}

function syncCartLinkAccessibleName() {
  const cartLink = document.querySelector(".cart-link");
  if (!cartLink) return;

  const baseLabel = cartLink.dataset.cartLabel || "Cart";
  const count = cartLink.querySelector(".cart-link__count")?.textContent.trim();
  const numericCount = Number.parseInt(count, 10);
  const label =
    Number.isFinite(numericCount) && numericCount > 0
      ? `${baseLabel}, ${numericCount} item${numericCount === 1 ? "" : "s"}`
      : baseLabel;
  cartLink.setAttribute("aria-label", label);
}

let rebuyCartOpenPending = false;
let rebuyCartOpenAttempts = 0;
let rebuyCartOpenRetry;

function showPendingRebuyCart() {
  if (!rebuyCartOpenPending) return;

  const smartCart = window.Rebuy?.SmartCart;
  if (typeof smartCart?.show !== "function") return;

  if (!smartCart.status || smartCart.status === "ready") {
    smartCart.show();
  }

  if (rebuyCartOpenPending && rebuyCartOpenAttempts < 40) {
    rebuyCartOpenAttempts += 1;
    clearTimeout(rebuyCartOpenRetry);
    rebuyCartOpenRetry = setTimeout(showPendingRebuyCart, 250);
  }
}

function openRebuyCart(event) {
  if (theme.settings.cart_type !== "rebuy") return;

  const cartLink = event.target.closest?.(".cart-link");
  if (
    !cartLink ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  ) {
    return;
  }

  const smartCart = window.Rebuy?.SmartCart;
  if (typeof smartCart?.show !== "function") return;

  event.preventDefault();
  rebuyCartOpenPending = true;
  rebuyCartOpenAttempts = 0;
  showPendingRebuyCart();
}

document.addEventListener("click", openRebuyCart);
document.addEventListener("rebuy:smartcart.ready", showPendingRebuyCart);
document.addEventListener("rebuy:smartcart.show", () => {
  rebuyCartOpenPending = false;
  clearTimeout(rebuyCartOpenRetry);
});

function setupCartLinkAccessibilityObserver() {
  const cartLink = document.querySelector(".cart-link");
  if (!cartLink) return;

  syncCartLinkAccessibleName();
  new MutationObserver(syncCartLinkAccessibleName).observe(cartLink, {
    childList: true,
    characterData: true,
    subtree: true,
  });
}

document.addEventListener("click", (event) => {
  const disclosure = event.target.closest(
    ".filter-group__heading[aria-controls]",
  );
  if (!disclosure) return;

  const syncDisclosureState = () => {
    const panel = document.getElementById(
      disclosure.getAttribute("aria-controls"),
    );
    if (!panel) return;
    disclosure.setAttribute(
      "aria-expanded",
      panel.classList.contains("toggle-target--hidden") ? "false" : "true",
    );
  };

  requestAnimationFrame(syncDisclosureState);
  setTimeout(syncDisclosureState, 400);
});

// Function to set up a MutationObserver on '.rebuy-cart__flyout-recommendations'
// This function sets up a MutationObserver to watch for changes in the DOM within a specific element
function setupImageAltAttributeObserver() {
  const targetNode = document.querySelector(
    ".rebuy-cart__flyout-recommendations",
  );

  if (targetNode) {
    // Set up the observer
    const observer = new MutationObserver(function (mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (mutation.type === "childList") {
          clearAltAttributes();
          updateAriaHiddenAttributes();
        }
      }
    });

    observer.observe(targetNode, { childList: true, subtree: true });
  } else {
    // Node not found, check again after a delay
    setTimeout(setupImageAltAttributeObserver, 500); // Adjust the delay as needed
  }
}
// This function handles Rebuy events and re-initializes the observer setup
function handleRebuyEvents() {
  clearAltAttributes();
  updateAriaHiddenAttributes();
  updateDecorativeInjectedSvgAttributes();
  updateInjectedComponentAccessibility();
  setupDecorativeInjectedSvgObserver();
  setupImageAltAttributeObserver();
}

// Event listeners for Rebuy events
// These event listeners trigger the handleRebuyEvents function when the specified Rebuy events occur
document.addEventListener("DOMContentLoaded", function () {
  updateDecorativeInjectedSvgAttributes();
  updateInjectedComponentAccessibility();
  updateAccessibleTableNames();
  setupCartLinkAccessibilityObserver();
  setupDecorativeInjectedSvgObserver();
  updateSlickAccessibility();
  setupSlickAccessibilityObservers();
  updateHiddenInjectedIframeAttributes();
  setupHiddenInjectedIframeObserver();
});
setTimeout(() => {
  updateInjectedComponentAccessibility();
  updateAccessibleTableNames();
  updateSlickAccessibility();
  setupSlickAccessibilityObservers();
}, 1000);
setTimeout(() => {
  updateInjectedComponentAccessibility();
  updateAccessibleTableNames();
  updateSlickAccessibility();
  setupSlickAccessibilityObservers();
}, 5000);
document.addEventListener("rebuy:smartcart.ready", handleRebuyEvents);
document.addEventListener("rebuy:cart.change", handleRebuyEvents);

// Initial call to start the observer setup process
// This function call initiates the setup of the MutationObserver
updateDecorativeInjectedSvgAttributes();
updateInjectedComponentAccessibility();
updateAccessibleTableNames();
setupDecorativeInjectedSvgObserver();
updateSlickAccessibility();
setupSlickAccessibilityObservers();
updateHiddenInjectedIframeAttributes();
setupHiddenInjectedIframeObserver();
setupAccessibilityWidgetAlignment();
setupImageAltAttributeObserver();
//
//
// End of 01

// 02. Function to modify route badge button in the Rebuy Smart Cart
// This function modifies the behavior of a specific button in the smart cart

//
//
// End of 02

// 03. Function to add labels to variant selectors in the Rebuy Smart Cart
// This function adds labels to variant selectors in the product options
function rebuyCartAddLabelsToProductOptions() {
  var productOptions = document.querySelectorAll(
    ".rebuy-cart__flyout-recommendations .rebuy-product-options",
  );

  productOptions.forEach(function (option, index) {
    if (option.querySelector("label.product-variant-selector-label") === null) {
      var label = document.createElement("label");
      label.textContent = "Select product variant";
      label.classList.add("product-variant-selector-label");

      var select = option.querySelector("select");
      if (select) {
        if (!select.id) {
          select.id = "product-variant-select-" + index;
        }
        label.setAttribute("for", select.id);
      }

      option.insertBefore(label, option.firstChild);
    }
  });
}

// Debounced, scoped observer. Previously observed document.body subtree and fired on every
// unrelated mutation across the page.
let rebuyLabelsDebounce;
let rebuyLabelsObserver;
function setupMutationObserverForLabels() {
  if (rebuyLabelsObserver) return;
  const target = document.querySelector(".rebuy-cart__flyout") || document.body;
  rebuyLabelsObserver = new MutationObserver(function () {
    clearTimeout(rebuyLabelsDebounce);
    rebuyLabelsDebounce = setTimeout(rebuyCartAddLabelsToProductOptions, 300);
  });
  rebuyLabelsObserver.observe(target, { childList: true, subtree: true });
}

document.addEventListener("DOMContentLoaded", rebuyCartAddLabelsToProductOptions);
document.addEventListener("rebuy:smartcart.ready", setupMutationObserverForLabels, { once: true });
setTimeout(setupMutationObserverForLabels, 5000);
//
//
// End of 03

// 04. Function to set focus to the nearest select element in '.rebuy-product-block' in the Rebuy Smart Cart
// This function sets focus to the nearest select element in the '.rebuy-product-block' element
function rebuyCartFocusNearestSelect(event) {
  var button = event.target.closest(
    ".rebuy-product-block .rebuy-product-actions button",
  );
  if (button) {
    var productBlock = button.closest(".rebuy-product-block");
    if (productBlock) {
      // Adding a slight delay to allow for the select element to be ready
      setTimeout(function () {
        var selectElement = productBlock.querySelector(
          ".rebuy-product-options select",
        );
        if (selectElement) {
          selectElement.focus();
        }
      }, 100); // Delay of 100 milliseconds; adjust as necessary
    }
  }
}

// Event listener for the click event
// This event listener triggers the rebuyCartFocusNearestSelect function when a click event occurs
document.body.addEventListener("click", rebuyCartFocusNearestSelect);
//
//
// End of 04

// 05. Function to trap focus within the Route modal widget in the Rebuy Smart Cart
// This function traps focus within the modal
function rebuyCartTrapFocusRouteModal() {
  const modalElement = document.getElementById("rm-modal-container");
  if (!modalElement) return; // Check if the modal exists

  // Get all focusable elements within the modal
  const rebuyCartRouteModalFocusableElements = modalElement.querySelectorAll(
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])',
  );

  const rebuyCartRouteModalFirstElement =
    rebuyCartRouteModalFocusableElements[0];
  const rebuyCartRouteModalLastElement =
    rebuyCartRouteModalFocusableElements[
      rebuyCartRouteModalFocusableElements.length - 1
    ];

  modalElement.addEventListener("keydown", function (event) {
    if (event.key === "Tab") {
      if (event.shiftKey) {
        // If Shift+Tab is pressed, move focus to the last focusable element
        if (document.activeElement === rebuyCartRouteModalFirstElement) {
          event.preventDefault();
          rebuyCartRouteModalLastElement.focus();
        }
      } else {
        // If Tab is pressed, move focus to the first focusable element
        if (document.activeElement === rebuyCartRouteModalLastElement) {
          event.preventDefault();
          rebuyCartRouteModalFirstElement.focus();
        }
      }
    }
  });

  // Add the aria-modal attribute to indicate a modal dialog
  modalElement.setAttribute("aria-modal", "true");
  // Add the aria-labelledby attribute with the appropriate label ID
  modalElement.setAttribute("aria-labelledby", "rebuyCartRouteModalTitle");
  // Set the tabindex attribute to -1 to allow programmatic focus
  modalElement.setAttribute("tabindex", "-1");
}

// Function to check if the modal is open and set up focus trapping
// This function checks if the modal is open and sets up focus trapping
function rebuyCartCheckModalOpenRouteModal() {
  const routeModal = document.querySelector(".route-modal.rm-open");
  if (routeModal) {
    // If route-modal has class rm-open, call the focus trapping function
    rebuyCartTrapFocusRouteModal();

    // Add an ID to the route-modal__title element
    const routeModalTitleElement = routeModal.querySelector(
      ".route-modal__title",
    );
    if (routeModalTitleElement) {
      routeModalTitleElement.id = "rebuyCartRouteModalTitle";
    }
  }
}

// Debounced observer for route modal open state. The modal is injected by Rebuy,
// so we watch its flyout container (or fall back to body) and throttle to 200ms.
let rebuyRouteModalDebounce;
function setupRebuyRouteModalObserver() {
  const target = document.querySelector(".rebuy-cart__flyout") || document.body;
  const observer = new MutationObserver(function () {
    clearTimeout(rebuyRouteModalDebounce);
    rebuyRouteModalDebounce = setTimeout(rebuyCartCheckModalOpenRouteModal, 200);
  });
  observer.observe(target, { childList: true, subtree: true });
}
document.addEventListener("rebuy:smartcart.ready", setupRebuyRouteModalObserver, { once: true });
setTimeout(setupRebuyRouteModalObserver, 5000);

rebuyCartCheckModalOpenRouteModal();
//
//
// End of 05

// Set up a MutationObserver to watch for changes in the cart in flyout apps section
function setupRebuyCartRouteNoticeObserver() {
  const routeModalOpener = document.querySelector('.pw-route-protection .default-text');
  if (routeModalOpener) {
    const targetNode = document.querySelector('.rebuy-cart__flyout-apps');
    const observer = new MutationObserver(function (mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (mutation.type === "childList") {
          rebuyCartRouteNoticeUpdate();
        }
      }
    });
    observer.observe(targetNode, { childList: true, subtree: true });
  }
}

// Function to update route notice attributes and add proper events to the div that should open the modal
function rebuyCartRouteNoticeUpdate() {
  const routeModalOpener = document.querySelector('.pw-route-protection .default-text');
  if (routeModalOpener) {
    const detaulModalOpener = routeModalOpener.querySelector('.pw-learn-more');
    routeModalOpener.setAttribute('tabindex', '0');
    routeModalOpener.setAttribute('role', 'button');
    routeModalOpener.setAttribute('aria-haspopup', 'dialog');
    routeModalOpener.setAttribute('aria-label', 'Learn More about Package Protection');

    routeModalOpener.addEventListener('click', function(event) {
      detaulModalOpener.click();
    });

    routeModalOpener.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === '' || event.code  === 'Space') {
        detaulModalOpener.click();
      }
    });
  }
}

document.addEventListener("rebuy:cart.change", setupRebuyCartRouteNoticeObserver);
